// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d-flex[data-v-39ab2b8a] {\n  display: flex;\n}\n.flex-column[data-v-39ab2b8a] {\n  flex-direction: column;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
